(() => {
  if (window.hgWebsiteR1) return;
  window.hgWebsiteR1 = true;
  const controllers = new WeakMap();
  const initialize = root => {
    root.querySelectorAll('[data-hg-page]').forEach(page => {
      if (controllers.has(page)) return;
      const abort = new AbortController();
      const cleanups = [];
      const on = (node, event, fn, options = {}) => node.addEventListener(event, fn, {...options, signal: abort.signal});
      let frame = 0;
      const updates = [];
      const update = () => { frame = 0; updates.forEach(fn => fn()); };
      const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
      const track = page.querySelector('#meal-track');
      if (track) {
        const carousel = track.closest('.meal-carousel');
        const prev = carousel.querySelector('.meal-prev');
        const next = carousel.querySelector('.meal-next');
        const status = carousel.querySelector('.meal-position');
        const cards = [...track.children];
        updates.push(() => {
          const max = Math.max(0, track.scrollWidth - track.clientWidth);
          prev.disabled = track.scrollLeft <= 2;
          next.disabled = track.scrollLeft >= max - 2;
          const bounds = track.getBoundingClientRect();
          const visible = cards.map((card, index) => ({index: index + 1, bounds: card.getBoundingClientRect()}))
            .filter(card => card.bounds.left >= bounds.left - 2 && card.bounds.right <= bounds.right + 2)
            .map(card => card.index);
          status.textContent = visible.length ? (visible.length === 1 ? visible[0] : visible[0] + '–' + visible.at(-1)) + ' / ' + cards.length : '';
        });
        const move = direction => {
          if (cards.length < 2) return;
          const step = cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          track.scrollBy({left: direction * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        };
        on(prev, 'click', () => move(-1));
        on(next, 'click', () => move(1));
        on(track, 'keydown', event => {
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') { event.preventDefault(); move(event.key === 'ArrowLeft' ? -1 : 1); }
        });
        let settle;
        on(track, 'scroll', () => { clearTimeout(settle); settle = setTimeout(schedule, 120); }, {passive: true});
        cleanups.push(() => clearTimeout(settle));
      }
      const hero = page.querySelector('.kit-hero');
      const finalOffer = page.querySelector('.kit-final');
      const sticky = page.querySelector('.mobile-buy');
      if (hero && finalOffer && sticky) {
        const mobile = matchMedia('(max-width: 760px)');
        updates.push(() => {
          const heroPassed = hero.getBoundingClientRect().bottom <= 0;
          const finalBounds = finalOffer.getBoundingClientRect();
          const finalVisible = finalBounds.top < innerHeight && finalBounds.bottom > 0;
          const focused = sticky.contains(document.activeElement);
          sticky.hidden = !mobile.matches || (!focused && (!heroPassed || finalVisible));
        });
        on(window, 'scroll', schedule, {passive: true});
        on(sticky, 'focusout', schedule);
      }
      on(window, 'resize', schedule);
      if ('ResizeObserver' in window) {
        const observer = new ResizeObserver(schedule);
        [track, hero, finalOffer].filter(Boolean).forEach(node => observer.observe(node));
        cleanups.push(() => observer.disconnect());
      }
      controllers.set(page, () => { abort.abort(); cancelAnimationFrame(frame); cleanups.forEach(fn => fn()); controllers.delete(page); });
      update();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('[data-hg-page]').forEach(page => controllers.get(page)?.());
  });
})();
